module.exports = __webpack_public_path__ + "img/transerror.ff9cfcf1.jpg";